let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("hGEfo")]).then(() => parcelRequire('8fEoF'));